import { render, staticRenderFns } from "./ownAds.vue?vue&type=template&id=6928eb4e&scoped=true"
import script from "./ownAds.vue?vue&type=script&lang=js"
export * from "./ownAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6928eb4e",
  null
  
)

export default component.exports